'use strict';

import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';
import store from '@/store';

const config = {
  // baseURL: process.env.baseURL || process.env.apiUrl || ""
  // timeout: 60 * 1000, // Timeout
  // withCredentials: true, // Check cross-site Access-Control
};

const _axios = axios.create(config);

_axios.interceptors.request.use(
  // Do something before request is sent
  (conf: AxiosRequestConfig) => {
    const user = store.getters["login/user"];
    if (user) {
      const authToken = user.access_token;
      if (authToken) {
        conf.headers.Authorization = `Bearer ${authToken}`;
      }
    }
    return conf;
  },

  // Do something with request error
  (error: any) => Promise.reject(error),
);

// Add a response interceptor
_axios.interceptors.response.use(
  (response: any) => {
    return response;
  },
  (error: any) => {
    if (error.response.status === 401) {
      window.localStorage.clear();
      window.location.href = "/callback?type=warning&msg=session has expired, please Login";
    }
    return Promise.reject(error)
  },
);

export function setJWT(jwt: string) {
  _axios.defaults.headers.common['Authorization'] = `Bearer ${jwt}`;
}

export function removeJWT() {
  _axios.defaults.headers.common['Authorization'] = '';
}

export default _axios;
